<template>
  <div>
    <div>
      <input type="hidden" v-model="model.channel_id" />
      <b-form-group :label="$t('message.Адрес') + ':'" label-for="Address">
        <b-form-input
          id="Address"
          type="text"
          v-model="model.address"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group :label="$t('message.Включен') + ':'" label-for="Enabled">
        <b-form-checkbox-group v-model="model.enabled" id="streamEnabled">
          <b-form-checkbox value="true"></b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-form-group label="Service:" label-for="Service">
        <v-select
          v-model="model.service"
          :options="this.services"
          label="name"
          :get-option-label="getLabel"
        ></v-select>
      </b-form-group>
      <b-form-group label="Начало записи:">
        <date-picker
          v-model="model.dvr_since"
          :lang="lang"
          :format="'DD MMM YYYY HH:mm'"
          :clearable="true"
        ></date-picker>
      </b-form-group>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
Vue.use(require("vue-moment"));

export default {
  name: "StreamForm",
  props: ["model"],
  components: { DatePicker },

  data() {
    return {
      services: [],
      lang: "ru"
      // momentFormat: {
      //   stringify: date => {
      //     return date ? moment.moment(date).format("YYYY-MM-DDTHH:mm") : null;
      //   },
      //   parse: value => {
      //     return value ? moment.moment(value, "LL").toDate() : null;
      //   }
      // }
    };
  },
  created: function() {
    let promise = this.$noname.get("services", { params: { perPage: 10000 } });

    return promise
      .then(data => {
        this.services = data.data.items;
      })
      .catch(this.$noname.HandleError);
  },
  methods: {
    getLabel(option) {
      return `[${option.id}] ${option.name} - ${option.address}`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/StreamForm.vue